// import * as requestFromServer from "./crud";

import {CategoriesSlice, callTypes} from "./slices";
import {categories} from "../../../utils/categories";

const {actions} = CategoriesSlice;

export const fetchCategories = () => dispatch => {
  dispatch(actions.startCall({callType: callTypes.list}));

  // return requestFromServer.getCategories()

  return Promise
    .resolve(categories)
    .then(response => {
      const categories = response;
      dispatch(actions.CategoriesFetched({categories}));
    })
    .catch(error => {
      error.clientMessage = "Can't find links";
      dispatch(actions.catchError({error, callType: callTypes.list}));
    });
};
